import { useEffect } from 'react';
import { useMeasure } from 'react-use';
import { useLayoutStore } from '../stores';

export function useHeaderHeight<T extends Element>() {
  const setHeaderHeight = useLayoutStore.use.setHeaderHeight();

  const [ref, { height }] = useMeasure<T>();

  useEffect(() => {
    document.body.style.setProperty('--header-height', `${height}px`);
    setHeaderHeight(height);
  }, [height, setHeaderHeight]);

  return ref;
}
